export const CLIENT_DETAIL_TABS = {
  ITEMS: 0,
  CHECKS: 1,
  ORDERS: 2,
  BALANCE: 3,
  PROFILE: 4,
};

export const CLIENT_TAB_SLUG_BY_INDEX = {
  [CLIENT_DETAIL_TABS.ITEMS]: 'items',
  [CLIENT_DETAIL_TABS.CHECKS]: 'checks',
  [CLIENT_DETAIL_TABS.ORDERS]: 'orders',
  [CLIENT_DETAIL_TABS.BALANCE]: 'balance',
  [CLIENT_DETAIL_TABS.PROFILE]: 'profile',
};

export const CLIENT_TAB_INDEX_BY_SLUG = Object.fromEntries(
  Object.entries(CLIENT_TAB_SLUG_BY_INDEX).map(([index, slug]) => [slug, Number(index)])
);

export const CLIENT_TABS_WITH_ITEM_DETAIL = new Set(['orders', 'checks']);

export function getClientTabPath(clientId, tabSlug = 'items', itemId) {
  const base = `/clients/${clientId}/${tabSlug}`;
  return itemId ? `${base}/${itemId}` : base;
}

export function clientReturnState(clientId, tab) {
  if (!clientId) return {};
  const tabSlug = CLIENT_TAB_SLUG_BY_INDEX[tab] || 'items';
  return {
    returnTo: getClientTabPath(clientId, tabSlug),
    returnTab: tab,
  };
}

export function mergeNavState(baseState, locationState) {
  const { returnTo, returnTab } = locationState || {};
  if (!returnTo) return baseState;
  return { ...baseState, returnTo, returnTab };
}

export const OPEN_BALANCE_LIST_PATH = '/dashboard/metrics/open-balance';

export function safeInternalPath(value) {
  if (typeof value !== 'string') return null;
  if (!value.startsWith('/') || value.startsWith('//')) return null;
  return value;
}

/**
 * Previous/next list carried in React Router state.
 * A new browser tab does not receive this state, so it opens one client only.
 */
export function clientListNavFromState(state, clientId) {
  const ids = Array.isArray(state?.ids) ? state.ids.map(String) : [];
  const id = clientId != null ? String(clientId) : '';
  const index = ids.length > 0 ? ids.indexOf(id) : -1;
  return {
    ids,
    index,
    returnTo: safeInternalPath(state?.returnTo),
    hasPrev: index > 0,
    hasNext: index >= 0 && index < ids.length - 1,
  };
}

export function buildClientListNavState(ids, index, extras = {}) {
  const state = { ids, index };
  const returnTo = safeInternalPath(extras.returnTo);
  if (returnTo) state.returnTo = returnTo;
  if (extras.returnTab != null) state.returnTab = extras.returnTab;
  return state;
}

export function openBalanceListNavState(clientIds, clientId) {
  const ids = (clientIds || []).map(String);
  return buildClientListNavState(ids, ids.indexOf(String(clientId ?? '')), {
    returnTo: OPEN_BALANCE_LIST_PATH,
  });
}

export function getBackTarget(locationState, { path, labelKey }) {
  const { returnTo, returnTab: _returnTab, ids, index, ...rest } = locationState || {};
  if (returnTo) {
    const navState = ids?.length ? { ids, index, ...rest } : undefined;
    return {
      path: returnTo,
      state: navState,
      labelKey: 'clients.backToClient',
    };
  }
  return { path, state: undefined, labelKey };
}
